import React from 'react';
import PropTypes from 'prop-types';

import Card from '@material-ui/core/Card';
import InfoIcon from '@material-ui/icons/InfoOutlined';

import IndentedCardContent from '../../../../components/IndentedCardContent/IndentedCardContent';
import NotificationsCard from './NotificationsCard/NotificationsCard';
import HelpCard from '../../../../components/HelpCard/HelpCard';
import { getString } from '../../../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';
import analyticsApi from '../../../../api/analytics.js';

const stringsComponent = 'notifications';

class NotificationsSection extends React.Component {
  render() {
    const {
      classes,
      createPreferences,
      preferencesData,
      newNotificationPreferences,
      contactData,
      toggleContactModal,
    } = this.props;

    const portalGuidance = portalGuidances.find(
      (guidance) => guidance.Title === stringsComponent
    );

    return (
      <div className={classes.root}>
        <NotificationsCard
          createPreferences={createPreferences}
          preferencesData={preferencesData}
          newNotificationPreferences={newNotificationPreferences}
          contactData={contactData}
        />
        <br />
        <br />
        <HelpCard
          title={getString('help', 'TITLE')}
          subheading={getString('help', 'SUBHEADING')}
          content={portalGuidance ? portalGuidance.Content : null}
          contact={portalGuidance ? portalGuidance.Contact : null}
          faqs={portalGuidance ? portalGuidance.FAQs : null}
          icon={<InfoIcon className={classes.infoIcon} />}
          toggleContactModal={toggleContactModal}
          gaEvent={analyticsApi.event}
        />
      </div>
    );
  }
}

NotificationsSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

NotificationsSection.defaultProps = {};

export default withStyles(styles)(NotificationsSection);
